<template>
    <div :class="'ol-product-content__center-list carousel-products-container '+carouselKey">
      <div  v-for="(product,i) in products" :key="'item-'+i+'-'+product.id+'-'+product.r_uni_product.slug">
        <router-link :to="product.bundling == 1 ? '/bundle/'+product.r_uni_product.slug : '/product/'+product.r_uni_product.slug" :title="product.r_uni_product.name">
          <div class="ol-home-product__content-item-list--item" style="width:100%">
            <figure class="ol-home-product__content-item-list--item-figure">          
              <!-- <div  v-for="(image,i) in product.r_uni_product.r_uni_product_images.slice(0, 3)" :key="'image-group-content-'+image.id" 
                  :class="'ol-home-product__content-item-list--item-figure-link ol-home-product__content-item-list--item-figure-link--'+(i+1)">
                  <img :src="image.image_url" :alt="image.alt_text" :title="product.r_uni_product.name">
              </div> -->
              <span v-if="product.r_uni_product.r_uni_product_suasanas">
                <div v-for="(image,i) in product.r_uni_product.r_uni_product_suasanas.slice(0, 3)" :key="image.id" :class="'ol-home-product__content-item-list--item-figure-link ol-home-product__content-item-list--item-figure-link--'+(i+1)">
                  <img :src="image.image_url" :alt="image.alt_text" :title="product.r_uni_product.name">
                </div>
              </span>
              <!-- <span v-if="product.r_uni_product.r_uni_product_images && product.r_uni_product.r_uni_product_suasanas.length < 1">
                <div v-for="(image,i) in product.r_uni_product.r_uni_product_images.slice(0, 3)" :key="image.id" :class="'ol-home-product__content-item-list--item-figure-link ol-home-product__content-item-list--item-figure-link--'+(i+1)">
                  <img :src="image.image_url" :alt="image.alt_text" :title="product.r_uni_product.name">
                </div>
              </span> -->
              <div v-if="product.r_uni_product.seo_4 == 'GRATIS'" class="promotion-free">
                  <span class="one-lines"><b>{{ product.r_uni_product.seo_4 }}</b>&nbsp;{{ product.r_uni_product.seo_5 }}</span>
              </div>
              <div v-if="product.r_uni_product.seo_4 == 'FLASH SALE'" class="promotion-flashsale">
                  <span class="one-lines"><b>{{ product.r_uni_product.seo_4 }}</b>&nbsp;{{ product.r_uni_product.seo_5 }}</span>
              </div>
              <div v-if="product.r_uni_product.seo_4 == 'KOMBO HEMAT'" class="promotion-combo">
                  <span class="one-lines"><b>{{ product.r_uni_product.seo_4 }}</b>&nbsp;{{ product.r_uni_product.seo_5 }}</span>
              </div>
            </figure>
            <h3 class="ol-home-product__content-item-list--item-title">
              {{product.r_uni_product.name}}
            </h3>
            <span v-if="product.r_uni_product.discount_max && product.r_uni_product.discount_max != '0%'" class="ol-home-product__content-item-list--item-discount">{{product.r_uni_product.discount_max}}<br>OFF</span>
            <div class="ol-home-product__content-item-list--item-price">
                <span class="ol-home-product__content-item-list--item-price-real">{{product.r_uni_product.price_normal_min}}</span>
                <small class="ol-home-product__content-item-list--item-price-discount">{{product.r_uni_product.price_discount_min}}</small>
            </div>
            <span v-if="product.r_uni_product.total_sales != 0"><i class="fas fa-star" style="color:gold;"></i> {{product.rating}} | Terjual {{product.r_uni_product.total_sales}}</span>
            <span v-if="product.r_uni_product.total_sales == 0">&nbsp;</span>
          </div>
        </router-link>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "CarouselProductGroup",
    props: ['products', 'carouselKey'],
    mounted() {
      this.initSlick(this.carouselKey);
    },
    methods: {
      initSlick(carouselKey) {
        $(".carousel-products-container."+carouselKey).slick({
          slidesToScroll: 1,
          slidesToShow: 4,
          dots: !0,
          autoplay: !0,
          autoplaySpeed: 5e3,
          arrows: !0,
          pauseOnFocus: !1,
          infinite: !0,
          speed: 500,
          fade: !1,
          responsive: [{
            breakpoint: 550,
            settings: {
              slidesToShow: 1,
            },
          }],
        });
      }
    }
  };
  </script>
  
  <style lang="css" scoped>
  @import "../../assets/css/_endorsement.css";
  @import "../../assets/js/slick/slick.css";
  </style>
  